(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Module_tr', Module_tr);

    Module_tr.$inject = ['$resource'];

    function Module_tr ($resource) {
        var resourceUrl =  'api/module-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
